var splide = document.querySelector('#splide');
if (splide) {
    new Splide('#splide', {
        classes: {
            pagination: 'splide__pagination your-class-pagination',
            page: 'splide__pagination__page your-class-page',
        },
        autoplay: true, // 自動再生
        type: 'loop', // ループ
        pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
        pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
        arrows: true,
        interval: 4000, // 自動再生の間隔
        speed: 1000, // スライダーの移動時間
        gap: "24px", // スライド間の余白
        perPage: 1, // スライダーのviewの枚数
        trimSpace: true, //余白の削除
        perMove: 1,
        arrowPath: ' ', //矢印のSVGパスを指定
        breakpoints: {
            768: {
                perPage: 1, // 500px未満の表示枚数
                padding: "16%", // スライダーの左右の余白
            },
        },
    }).mount();
}